import {
  MODALIDADE_INEDITOS,
  MODALIDADE_CURADORIA,
  DESCONTO_UPGRADE,
  PLANO_ANUAL,
} from '../../constants'
import { normalizeString } from '../../utils/formatter/formatter'

export const getValorPlano = ( assinatura, valorOriginalPlano, modalidade=null, plano=null, retornarValorKit=null ) => {
  if ( !assinatura?.ativoDesde ) {
    return valorOriginalPlano
  }

  const getNumeroKits = ( nomePlano ) => {
    const planosKits = {
      'anual': 12,
      'mensal': 1,
      'semestral': 6,
      'trimestral': 3,
    }
    return planosKits[ nomePlano ]
  }

  const createDate = ( obj ) => new Date(
    obj.anoCorteNovoValorPlano,
    obj.mesCorteNovoValorPlano - 1,
    obj.diaCorteNovoValorPlano
  )


  const modalidadeNormalizada = normalizeString( modalidade || assinatura.modalidade )
  const planoNormalizado = normalizeString( plano || assinatura.plano )
  const usarValorKit = retornarValorKit || false
  const numeroKits = getNumeroKits( planoNormalizado )

  const valoresDict = {
    [ normalizeString( MODALIDADE_INEDITOS.visualizacao ) ]: [
      {
        'anoCorteNovoValorPlano': 2025,
        'diaCorteNovoValorPlano': 3,
        'mesCorteNovoValorPlano': 12,
        'valorAntigo': {
          'anual': 790.8,
          'mensal': 86.9,
          'trimestral': 221.7,
        }
      },
      {
        'anoCorteNovoValorPlano': 2025,
        'diaCorteNovoValorPlano': 11,
        'mesCorteNovoValorPlano': 3,
        'valorAntigo': {
          'anual': 790.8,
          'mensal': 84.9
        }
      },
      {
        'anoCorteNovoValorPlano': 2024,
        'diaCorteNovoValorPlano': 1,
        'mesCorteNovoValorPlano': 11,
        'valorAntigo': {
          'anual': 766.8,
          'mensal': 76.9
        }
      },
    ],
    [ normalizeString( MODALIDADE_CURADORIA.visualizacao ) ]: [
      {
        'anoCorteNovoValorPlano': 2025,
        'diaCorteNovoValorPlano': 3,
        'mesCorteNovoValorPlano': 12,
        'valorAntigo': {
          'anual': 886.8,
          'mensal': 94.9,
          'trimestral': 242.7,
        }
      },
      {
        'anoCorteNovoValorPlano': 2025,
        'diaCorteNovoValorPlano': 11,
        'mesCorteNovoValorPlano': 3,
        'valorAntigo': {
          'anual': 886.8,
          'mensal': 84.9
        }
      },
      {
        'anoCorteNovoValorPlano': 2024,
        'diaCorteNovoValorPlano': 1,
        'mesCorteNovoValorPlano': 11,
        'valorAntigo': {
          'anual': 862.8,
          'mensal': 84.9
        }
      },
      {
        'anoCorteNovoValorPlano': 2023,
        'diaCorteNovoValorPlano': 1,
        'mesCorteNovoValorPlano': 11,
        'valorAntigo': {
          'anual': 838.8,
          'mensal': 84.9
        }
      },
    ]
  }

  if ( !( modalidadeNormalizada in valoresDict ) ) {
    return valorOriginalPlano
  }

  let valorPlano

  const valoresOrdenados = [ ...valoresDict[ modalidadeNormalizada ] ]
    .sort( ( valorA, valorB ) => createDate( valorA ) - createDate( valorB ) )

  for ( const valorDict of valoresOrdenados ) {
    const { valorAntigo } = valorDict

    if ( !( planoNormalizado in valorAntigo ) ) {
      return valorOriginalPlano
    }

    const dataCorteNovoValorPlano = createDate( valorDict )

    const isAssinaturaPreviaDataDeCorte = new Date( assinatura?.ativoDesde ) < dataCorteNovoValorPlano

    if ( isAssinaturaPreviaDataDeCorte ) {
      valorPlano = valorAntigo[ planoNormalizado ] / ( usarValorKit ? numeroKits : 1 )
      break
    }
  }
  return valorPlano ?? valorOriginalPlano
}

export const getTextoDescontoUpgradePlano = ( modalidade, plano, planoUpgrade ) => {
  try {
    const descontoUpgrade = DESCONTO_UPGRADE[ planoUpgrade.toLowerCase() ][ modalidade.toLowerCase() ][ plano.toLowerCase() ]
    const frasePresenteExclusivo = planoUpgrade === PLANO_ANUAL.slug ? ' e um presente exclusivo' : ''
    return `Assine o <strong>plano ${planoUpgrade}</strong> e ganhe + de ${descontoUpgrade} de desconto${frasePresenteExclusivo}.`
  } catch {
    return ''
  }
}
